import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05d0d26e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer_wrap" }
const _hoisted_2 = { class: "drawer_title" }
const _hoisted_3 = { class: "drawer_title_txt" }
const _hoisted_4 = { class: "drawer_form" }
const _hoisted_5 = { class: "drawer_form_input_wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dfiw_title required" }, "活动名称：", -1))
const _hoisted_7 = { class: "dfiw_content" }
const _hoisted_8 = { class: "drawer_form_input_wrap" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dfiw_title required" }, "抽奖范围：", -1))
const _hoisted_10 = { class: "dfiw_content" }
const _hoisted_11 = { class: "dfiw_content_row_col" }
const _hoisted_12 = {
  key: 0,
  class: "dfiw_content_row_col"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新上传的名单，需要保存后才能查看名单列表。", -1))
const _hoisted_14 = { class: "dfiw_content_row" }
const _hoisted_15 = { class: "dfiw_content_row_col" }
const _hoisted_16 = { class: "dfiw_content_row_col" }
const _hoisted_17 = {
  key: 0,
  class: "dfiw_content_row_col"
}
const _hoisted_18 = { class: "dfiw_content_row_col" }
const _hoisted_19 = {
  key: 0,
  class: "dfiw_content_row_col"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("参与用户必须打卡成功，才有几率中奖。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("(需要开启【注册观看】并且注册观看内需要有【手机号】收集来配合使用)。")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "过滤掉本次活动抽奖所有中过奖用户。", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "配合本地名单的分类，按照权重进行分配中奖人数。", -1))
const _hoisted_23 = { class: "dfiw_content_row_col" }
const _hoisted_24 = { class: "drawer_form_input_wrap" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dfiw_title" }, "中奖名单：", -1))
const _hoisted_26 = { class: "dfiw_content" }
const _hoisted_27 = { class: "dfiw_content_row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "base_color" }, "(包含结束的中奖名单）", -1))
const _hoisted_29 = { class: "drawer_form_input_wrap" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dfiw_title required" }, "电脑背景：", -1))
const _hoisted_31 = { class: "dfiw_content" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drawer_form_desc" }, "上传说明：建议尺寸1920*1080小于2M 支持jpg、jpeg、png、gif", -1))
const _hoisted_33 = { class: "drawer_form_input_wrap" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dfiw_title required" }, "手机背景：", -1))
const _hoisted_35 = { class: "dfiw_content" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drawer_form_desc" }, "上传说明：建议尺寸1125*2436小于2M 支持jpg、jpeg、png、gif", -1))
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "prize_item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "prize_item_title" }, "奖项名称：", -1))
const _hoisted_40 = { class: "prize_item_mar" }
const _hoisted_41 = { class: "prize_item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "prize_item_title" }, "奖品名称：", -1))
const _hoisted_43 = { class: "prize_item_mar" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "prize_item" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "prize_item_title" }, "中奖名额：", -1))
const _hoisted_48 = { class: "prize_item_mar" }
const _hoisted_49 = { class: "prize_item" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "prize_item_title" }, "奖品图片：", -1))
const _hoisted_51 = { class: "prize_item_mar" }
const _hoisted_52 = { class: "add_prize_box" }
const _hoisted_53 = { class: "drawer_footer" }
const _hoisted_54 = { class: "btn_group" }
const _hoisted_55 = { key: 0 }

import { reactive, ref, watch } from 'vue';
import { Checkbox, InputNumber, Button, Radio, message, Popover, Upload } from 'ant-design-vue';
import {
  QuestionCircleFilled,
  CloseOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
  UploadOutlined,
} from '@ant-design/icons-vue';
import CUpload from '@/components/CUpload.vue'; // 上传图片  组件
import LocalList from './LocalList.vue';
import AudienceList from './AudienceList.vue';
import FullList from './FullList.vue';
import Weight from './Weight.vue';
import { FileInfo, Applicant, AddViewClass, OneDa } from './lottery';
import router from '@/router';
import { getToken } from '@/plugins/cookie';
import http from '@/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateActiviLogttery',
  props: {
    datails: null
  },
  emits: ['click:callbackPage', 'click:onBack'],
  setup(__props: any, { emit }) {

const props = __props as {
  datails: {
    applicants: Applicant;
    addPageViewData: AddViewClass;
    show: boolean;
  };
};

const aCheckbox = Checkbox;
const aInputNumber = InputNumber;
const aButton = Button;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aPopover = Popover;
const aUpload = Upload;
const studioId = router.currentRoute.value.params.studioId;
const token = getToken();

const onBlack = () => {
  emit('click:callbackPage');
};
const onBack = () => {
  emit('click:onBack');
};

const applicants = ref<Applicant>({
  fixed: 0, //内定名单 报名人数
  local: 0, // 本地名单 报名人数
  user: 0, // 观众参与 报名人数
});
// 奖项数组
const awardArray = ref<OneDa[]>([
  {
    id: 0,
    reward: [
      {
        id: 0,
        pic: 0,
        pic_url: '', //图片地址
        title: '', //标题
        loading: false,
        number: 0, //中奖名额
      },
    ],
    title: '',
  },
]);
const addPageViewData = ref<AddViewClass>({
  bg: 0,
  bg_pc: 0,
  bg_pc_url: '',
  bg_url: '',
  data: awardArray.value,
  filter: false,
  fixed: false,
  id: 0,
  list: 0,
  local_join: true,
  sign_join: false,
  start_status: 0,
  title: '',
  user_join: false,
  win_history: 0,
  weight_status: false,
  weight: [],
});
const takeValue = () => {
  applicants.value = props.datails.applicants;
  addPageViewData.value = props.datails.addPageViewData;
  props.datails.addPageViewData.data ? (awardArray.value = props.datails.addPageViewData.data) : [];
  addPageViewData.value.weight = props.datails.addPageViewData.weight ? props.datails.addPageViewData.weight : [];
};
takeValue();
watch(
  () => props.datails.applicants,
  () => {
    applicants.value = props.datails.applicants;
  }
);
// 保存
const onSubmit = () => {
  message.destroy();
  try {
    awardArray.value.forEach((e) => {
      if (e.title === '') {
        throw '奖项信息不完整！';
      }
      e.reward.forEach((i) => {
        if (i.pic === 0 || i.title === '') {
          throw '奖品信息不完整！';
        }
      });
    });
    const data = {
      ...addPageViewData.value,
      filter: addPageViewData.value.filter ? '1' : '0',
      fixed: addPageViewData.value.fixed ? '1' : '0',
      local_join: addPageViewData.value.local_join ? '1' : '0',
      sign_join: addPageViewData.value.sign_join ? '1' : '0',
      user_join: addPageViewData.value.user_join ? '1' : '0',
      data: awardArray.value,
      studio_id: studioId,
      local_name_list: temporaryKey.value,
      weight_status: addPageViewData.value.weight_status ? '1' : '0',
      weight: addPageViewData.value.weight,
    };
    // // 编辑
    if (props.datails.show) {
      http.lottery
        .drawEditNew(data)
        .then((res) => {
          message.success(res.data.message);
          onBlack();
        })
        .catch((err) => {
          message.error(err.data.error);
        });
    } else {
      // 新建
      http.lottery
        .drawCreateNew(data)
        .then((res) => {
          message.success(res.data.message);
          onBlack();
        })
        .catch((err) => {
          message.error(err.data.error);
        });
    }
  } catch (err: any) {
    message.error(err);
  }
};
// 上传图片
const fileList = ref([]);
const loading = reactive({
  pc: false,
  mobile: false,
});
const UploadImages = (info: FileInfo, keys: string, i?: any) => {
  if (info.file.status === 'uploading') {
    loading[keys] = true;
    i ? (i.loading = true) : '';
    return;
  } else if (info.file.status === 'error') {
    loading[keys] = false;
    i.loading = false;
    message.error('上传失败');
  } else if (info.file.status === 'done') {
    if (info.file?.response?.code === 200) {
      switch (keys) {
        case 'pc':
          addPageViewData.value.bg_pc_url = info.file?.response?.data.url;
          addPageViewData.value.bg_pc = info.file?.response?.data.id;
          break;
        case 'mobile':
          addPageViewData.value.bg_url = info.file?.response?.data.url;
          addPageViewData.value.bg = info.file?.response?.data.id;
          break;
        default:
          i.pic_url = info.file?.response?.data.url;
          i.pic = info.file?.response?.data.id;
          break;
      }
    } else {
      message.error(info.file?.response?.error);
    }
    loading[keys] = false;
    i ? (i.loading = false) : '';
  }
};
const clearImg = (keyword: string, i: any) => {
  switch (keyword) {
    case 'pc':
      addPageViewData.value.bg_pc_url = '';
      addPageViewData.value.bg_pc = 0;
      break;
    case 'mobile':
      addPageViewData.value.bg_url = '';
      addPageViewData.value.bg = 0;
      break;
    default:
      i.pic_url = '';
      i.pic = 0;
      break;
  }
};
const temporaryKey = ref();
// 上传名单
const uploadList = (info: FileInfo) => {
  if (info.file.status === 'done') {
    if (info.file?.response?.code === 200) {
      applicants.value.local = info.file?.response?.data.number;
      temporaryKey.value = info.file?.response?.data.key;
      message.success(info.file?.response?.message);
    } else {
      message.error(info.file?.response?.error);
    }
  }
};
// 添加奖项
const createPrize = () => {
  awardArray.value.push({
    reward: [
      {
        pic: 0,
        title: '', //标题
        number: 0,
      },
    ],
    title: '',
  });
};
// 删除奖项
const delPrize = (index: number) => {
  awardArray.value.splice(index, 1);
};
// 添加奖品
const createItem = (arr: any) => {
  arr.push({
    pic: 0,
    title: '', //标题
    number: 0,
  });
};
// 删除奖品
const delItem = (arr: any, o: number) => {
  arr.splice(o, 1);
};
// 三级页面
const thirPage = ref(false);
const listType = ref(0);
const onOpenUserList = (index: number) => {
  thirPage.value = true;
  listType.value = index;
};
const callbackSecPage = () => {
  thirPage.value = false;
  listType.value = 0;
  const data = {
    studio_id: studioId,
    draw_new_id: addPageViewData.value.id,
  };
  http.lottery.getMemberNumNew({ params: data }).then((res) => {
    applicants.value = res.data.data;
  });
};

const getWeight = (data: any) => {
  addPageViewData.value.weight = data;
};
const callBackW = () => {
  thirPage.value = false;
  listType.value = 0;
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(addPageViewData.value.title ? '编辑抽奖' : '新建抽奖'), 1),
        _createVNode(_unref(aButton), {
          type: "link",
          class: "drawer_title_back",
          onClick: onBack
        }, {
          default: _withCtx(() => [
            _createTextVNode("返回>>")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_a_input, {
              value: addPageViewData.value.title,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((addPageViewData.value.title) = $event)),
              class: "dicf_item_input"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(["dfiw_content_row", { checked: addPageViewData.value.local_join }])
            }, [
              _createVNode(_unref(aCheckbox), {
                checked: addPageViewData.value.local_join,
                "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((addPageViewData.value.local_join) = $event)),
                class: "dfiw_content_row_checkbox"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("本地名单")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createElementVNode("div", _hoisted_11, "报名人数：" + _toDisplayString(applicants.value.local) + "人", 1),
              (props.datails.show)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_unref(aButton), {
                      type: "link",
                      class: "dfiw_content_row_btn",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (onOpenUserList(1)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("本地名单")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(aPopover), null, {
                content: _withCtx(() => [
                  _hoisted_13
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionCircleFilled), { class: "tips ml_8" })
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_unref(aUpload), {
                "file-list": fileList.value,
                "onUpdate:fileList": _cache[3] || (_cache[3] = ($event: any) => ((fileList).value = $event)),
                name: "file",
                multiple: true,
                action: "/api/v1/draw/upload_local_new",
                headers: { token: _unref(token) },
                data: () => ({ studio_id: _unref(studioId), draw_new_id: addPageViewData.value.id ? addPageViewData.value.id : 0 }),
                "show-upload-list": false,
                onChange: uploadList,
                accept: ".xls,.xlsx,.csv"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(aButton), { class: "dfiw_content_row_upload mod_modal_btn" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(UploadOutlined)),
                      _createTextVNode("上传名单")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["file-list", "headers", "data"]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_unref(aButton), {
                  type: "link",
                  class: "dfiw_content_row_btn",
                  href: "https://static.lighos.com/default/lottery.xlsx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("下载模版")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["dfiw_content_row", { checked: addPageViewData.value.user_join }])
            }, [
              _createVNode(_unref(aCheckbox), {
                checked: addPageViewData.value.user_join,
                "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((addPageViewData.value.user_join) = $event)),
                class: "dfiw_content_row_checkbox"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("观众参与")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createElementVNode("div", _hoisted_16, "报名人数：" + _toDisplayString(applicants.value.user) + "人", 1),
              (props.datails.show)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(_unref(aButton), {
                      type: "link",
                      class: "dfiw_content_row_btn",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (onOpenUserList(2)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("观众参与名单")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["dfiw_content_row", { checked: addPageViewData.value.fixed }])
            }, [
              _createVNode(_unref(aCheckbox), {
                checked: addPageViewData.value.fixed,
                "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((addPageViewData.value.fixed) = $event)),
                class: "dfiw_content_row_checkbox"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("内定名单")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createElementVNode("div", _hoisted_18, "报名人数：" + _toDisplayString(applicants.value.fixed) + "人", 1),
              (props.datails.show)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_unref(aButton), {
                      type: "link",
                      class: "dfiw_content_row_btn",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (onOpenUserList(3)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("全部名单")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["dfiw_content_row", { checked: addPageViewData.value.sign_join }])
            }, [
              _createVNode(_unref(aCheckbox), {
                checked: addPageViewData.value.sign_join,
                "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((addPageViewData.value.sign_join) = $event)),
                class: "dfiw_content_row_checkbox"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("打卡参与")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createVNode(_unref(aPopover), null, {
                content: _withCtx(() => [
                  _hoisted_20
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionCircleFilled), { class: "tips" })
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["dfiw_content_row", { checked: addPageViewData.value.filter }])
            }, [
              _createVNode(_unref(aCheckbox), {
                checked: addPageViewData.value.filter,
                "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((addPageViewData.value.filter) = $event)),
                class: "dfiw_content_row_checkbox"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("过滤已中奖观众")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createVNode(_unref(aPopover), { placement: "right" }, {
                content: _withCtx(() => [
                  _hoisted_21
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionCircleFilled), { class: "tips" })
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["dfiw_content_row", { checked: addPageViewData.value.weight_status }])
            }, [
              _createVNode(_unref(aCheckbox), {
                checked: addPageViewData.value.weight_status,
                "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((addPageViewData.value.weight_status) = $event)),
                class: "dfiw_content_row_checkbox"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("权重设置")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createVNode(_unref(aPopover), { placement: "right" }, {
                content: _withCtx(() => [
                  _hoisted_22
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionCircleFilled), { class: "tips" })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_unref(aButton), {
                  type: "link",
                  class: "dfiw_content_row_btn",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (onOpenUserList(4)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("权重管理")
                  ]),
                  _: 1
                })
              ])
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_unref(aRadioGroup), {
                value: addPageViewData.value.list,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((addPageViewData.value.list) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(aRadio), { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("本轮")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aRadio), { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("全部"),
                      _hoisted_28
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createVNode(CUpload, {
              "file-list": fileList.value,
              "image-name": addPageViewData.value.bg_pc_url,
              loading: loading.pc,
              "handle-change": (info) => UploadImages(info, 'pc', ''),
              "click-stop": () => clearImg('pc', ''),
              class: "dfiw_conten_pcload"
            }, null, 8, ["file-list", "image-name", "loading", "handle-change", "click-stop"])
          ])
        ]),
        _hoisted_32,
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createVNode(CUpload, {
              "file-list": fileList.value,
              "image-name": addPageViewData.value.bg_url,
              loading: loading.mobile,
              "handle-change": (info) => UploadImages(info, 'mobile', ''),
              "click-stop": () => clearImg('mobile', ''),
              class: "dfiw_conten_mload"
            }, null, 8, ["file-list", "image-name", "loading", "handle-change", "click-stop"])
          ])
        ]),
        _hoisted_36,
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(awardArray.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "prize_box"
            }, [
              _withDirectives(_createElementVNode("span", {
                class: "del_prize",
                onClick: ($event: any) => (delPrize(index))
              }, [
                _createVNode(_unref(CloseOutlined))
              ], 8, _hoisted_37), [
                [_vShow, awardArray.value.length > 1]
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_a_input, {
                    value: item.title,
                    "onUpdate:value": ($event: any) => ((item.title) = $event),
                    class: "prize_item_input"
                  }, null, 8, ["value", "onUpdate:value"])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.reward, (i, o) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i.id,
                  style: {"margin-top":"15px"}
                }, [
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_component_a_input, {
                        value: i.title,
                        "onUpdate:value": ($event: any) => ((i.title) = $event),
                        class: "prize_item_input"
                      }, null, 8, ["value", "onUpdate:value"])
                    ]),
                    _withDirectives(_createElementVNode("span", {
                      class: "add_prize_item",
                      onClick: ($event: any) => (delItem(item.reward, o))
                    }, [
                      _createVNode(_unref(MinusCircleOutlined))
                    ], 8, _hoisted_44), [
                      [_vShow, item.reward.length > 1]
                    ]),
                    _withDirectives(_createElementVNode("span", {
                      class: "add_prize_item",
                      onClick: ($event: any) => (createItem(item.reward))
                    }, [
                      _createVNode(_unref(PlusCircleOutlined))
                    ], 8, _hoisted_45), [
                      [_vShow, o === item.reward.length - 1]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_unref(aInputNumber), {
                        value: i.number,
                        "onUpdate:value": ($event: any) => ((i.number) = $event),
                        min: 0,
                        class: "prize_item_input"
                      }, null, 8, ["value", "onUpdate:value"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(CUpload, {
                        "file-list": fileList.value,
                        "image-name": i.pic_url,
                        loading: i.loading,
                        "handle-change": (info) => UploadImages(info, '', i),
                        "click-stop": () => clearImg('prize', i),
                        class: "prize_item_upload"
                      }, null, 8, ["file-list", "image-name", "loading", "handle-change", "click-stop"])
                    ])
                  ])
                ]))
              }), 128))
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_unref(aButton), {
              class: "add_prize",
              onClick: createPrize
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createVNode(_unref(aButton), {
            class: "mod_modal_btn",
            onClick: onBack
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_unref(aButton), {
            class: "mod_modal_btn mod_type_primary",
            onClick: onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          })
        ])
      ])
    ], 512), [
      [_vShow, !thirPage.value]
    ]),
    (thirPage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          (listType.value === 1)
            ? (_openBlock(), _createBlock(LocalList, {
                key: 0,
                "data-source": {
          drawType: 2,
          drawId: addPageViewData.value.id,
        },
                "onClick:callbackSecPage": callbackSecPage
              }, null, 8, ["data-source"]))
            : _createCommentVNode("", true),
          (listType.value === 2)
            ? (_openBlock(), _createBlock(AudienceList, {
                key: 1,
                "data-source": {
          drawType: 2,
          drawId: addPageViewData.value.id,
        },
                "onClick:callbackSecPage": callbackSecPage
              }, null, 8, ["data-source"]))
            : _createCommentVNode("", true),
          (listType.value === 3)
            ? (_openBlock(), _createBlock(FullList, {
                key: 2,
                "data-source": {
          drawType: 2,
          drawId: addPageViewData.value.id,
        },
                "onClick:callbackSecPage": callbackSecPage
              }, null, 8, ["data-source"]))
            : _createCommentVNode("", true),
          (listType.value === 4)
            ? (_openBlock(), _createBlock(Weight, {
                key: 3,
                "data-source": addPageViewData.value.weight,
                "onClick:callbackSecPage": callBackW,
                "onClick:updataList": getWeight
              }, null, 8, ["data-source"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})